import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
  


@Injectable({
    providedIn: 'root'
})
export class RoboflowService {

    private url = 'https://serverless.roboflow.com/medial-arch/1';
    private apiKey = environment.roboflow.apiKey

    constructor(private http: HttpClient) {}

    sendMedialArchImage(imageUrl: string): Observable<any> {
        const params = new HttpParams()
        .set('api_key', this.apiKey)
        .set('image', imageUrl)

        return this.http.post(this.url, null, { params });
    }
}
